import { gsap } from 'gsap'
import { tabs } from '../../vendor/baseFunctions/baseFunctions'
tabs()

class GalleryProduct {
	constructor() {
		this.gallery = document.querySelector('.gallery-product')
		this.mainImage = this.gallery.querySelector('.gallery-product__current-img img')
		this.miniatures = this.gallery.querySelectorAll('.miniatures-gallery-product__item')
		this.timeline = gsap.timeline()

		this.miniatures.forEach(item => {
			item.addEventListener('click', () => {
				if (!item.classList.contains('miniatures-gallery-product__item_active')) {
					this.setSrcMainImage(this.getDataMiniature(item))
					this.setActiveMiniature(item)
				}
			})
		})
	}

	setSrcMainImage(src) {
		this.mainImage.style.opacity = 0
		this.mainImage.setAttribute('src', src)
		this.timeline.to(this.mainImage, {
			opacity: 1,
			duration: 0.3
		})
	}

	getDataMiniature(item) {
		return item.getAttribute('data-image')
	}

	setActiveMiniature(item) {
		this.gallery.querySelector('.miniatures-gallery-product__item_active').classList.remove('miniatures-gallery-product__item_active')
		item.classList.add('miniatures-gallery-product__item_active')
	}
}
if (document.querySelector('.gallery-product')) {
	new GalleryProduct()
}

